export enum SizeImageEnum {
    ORG = "org",
    RESIZED = "resized",
    THUMB = "thumb",
}
